<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex justify-between">
      <span class="font-semibold text-primario text-lg tracking-wide">PRODUCCIÓN ESTIMADA</span>
    </div>
    <div id="chart">
      <highcharts
        :constructor-type="'ganttChart'"
        class="hc"
        :options="chartOptions"
        ref="chart"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductionEstimated",
  data() {
    return {
      chartOptions: {
        title: {
          text: "PRODUCCIÓN ESTIMADA"
        },
        xAxis: [
          {
            // first x-axis
            tickInterval: 1000 * 60 * 60 * 24, // 1 month
            dateTimeLabelFormats: {
              day: "%e"
            },
            labels: {
              style: {
                color: "#4A5568",
                fontSize: "10px"
              }
            }
          },
          {
            // second x-axis
            tickInterval: 1000 * 60 * 60 * 24 * 30 // 1 day
          }
        ],
        series: [
          {
            name: "Producción estimada",
            data: []
            /*data: [
              {
                id: "ZARA WOMAN",
                name: "ZARA WOMAN",
                color: "#CBD5E0",
              },
              {
                parent: "ZARA WOMAN",
                start: Date.UTC(2020, 7, 2),
                end: Date.UTC(2020, 11, 5),
                name: "SNOOPY PAJARITO",
              },
              {
                parent: "ZARA WOMAN",
                start: Date.UTC(2020, 8, 8),
                end: Date.UTC(2020, 10, 9),
                name: "SNOOPY CHICA",
              },
              {
                parent: "ZARA WOMAN",
                start: Date.UTC(2020, 10, 9),
                end: Date.UTC(2020, 11, 19),
                name: "SIMPSONS FAMILIA",
                color: "#ECC94B",
              },
              {
                parent: "ZARA WOMAN",
                start: Date.UTC(2020, 10, 10),
                end: Date.UTC(2020, 11, 23),
                name: "SIMPSONS GATO",
              },
            ],*/
          }
        ],
        colors: ["#48BB78"],
        navigator: {
          enabled: true,
          liveRedraw: true,
          series: {
            type: "gantt",
            pointPlacement: 0.5,
            pointPadding: 0.25
          },
          yAxis: {
            min: 0,
            max: 3,
            reversed: true
          }
        },
        scrollbar: {
          enabled: true
        },
        rangeSelector: {
          enabled: true,
          buttons: [
            {
              type: "month",
              count: 1,
              text: "1 Mes"
            },
            {
              type: "month",
              count: 3,
              text: "3 Meses"
            }
          ],
          buttonTheme: {
            width: 60
          }
        }
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$axios.get("api/Productions/GetEstimada").then((response) => {
        this.mapArray(response.data);
      });
    },
    mapArray(data) {
      let formattedData = data.map((element) => {
        let start = this.$moment.utc(element.sampleDateSignUp).unix() * 1000;
        let end = this.$moment.utc(element.fechaEstimadaLlegada).unix() * 1000;

        return {
          start: start,
          end: end,
          name: element.clientName + ' - ' + element.sectionName,
          color: element.sampleDelivered ? '#38A169' : '#ECC94B'
        };
      });

      this.chartOptions.series[0].data = formattedData;
    }
  }
};
</script>

<style>
.highcharts-credits {
  display: none;
}
</style>